/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Translation } from "react-i18next";
import GoogleMapDialog from "../GoogleMapDialog";
import { lockBody, unlockBody } from "../../function/bodyLockStatus";

class StoreDetail extends Component {
  state = {
    showDialog: false
  };

  closeMapDialog = () => {
    unlockBody();
    this.setState({
      showDialog: false
    });
  };

  viewMap = e => {
    lockBody();
    this.setState({
      showDialog: true
    });
  };
  render() {
    const { showDialog } = this.state;
    const { inStoreInfo, pickupOption } = this.props;
    const activeStore = pickupOption.pickup_stores.value
      ? inStoreInfo.find(
          data => data.storeId === pickupOption.pickup_stores.value
        )
      : null;

    return (
      <div className="store_details">
        {activeStore ? (
          <div key={activeStore.givenName}>
            <p className="subtitle shorter store-name">
              {activeStore.givenName}
              <a id="btnViewMap" className="btnViewMap" onClick={this.viewMap}>
                <span className="icon icon-header-icon-location"></span>
              </a>
            </p>
            <p className="desc">
              {activeStore.address}
              <br />
              <Translation>{t => t("checkout.monToSun")}</Translation>
              {activeStore.operatingHour}
              <br />
              <Translation>{t => t("checkout.tel")}</Translation>
              {activeStore.telephoneNumber}
            </p>
          </div>
        ) : null}

        {/* <div id="lightbox-map" class="lightbox-elm">
          <div class="lightbox-heading">
            <h2 class="text-title">分店位置</h2>
          </div>
          <div class="lightbox-body">
            <div id="mapWrapper">
              <div id="map"></div>
            </div>
          </div>
        </div> */}
        <GoogleMapDialog
          showDialog={showDialog}
          closeMapDialog={this.closeMapDialog.bind(this)}
          activeStore={activeStore}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  inStoreInfo: state.pickUpInStore.inStoreInfo
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(StoreDetail);
